/*
  kx-ga-events.js — the conversions this store actually has.

  Kalipso67 does not use Shopify's hosted checkout: the cart page carries a `contact` form,
  staff confirm stock, and a proforma invoice goes out by email (see the comment in
  sections/main-cart-footer.liquid). So GA4 will never receive `begin_checkout` or
  `purchase` from Shopify — the events Google's default setup waits for. What it can
  receive, and what is worth counting here:

    begin_checkout   the shopper starts filling the order form on the cart page
    generate_lead    that form posts successfully — the store's real conversion
    contact_click    a tap on a phone number or an email address
    calculator_use, quick_request_open, add_to_compare   intent before a request (since 4 Nov 2026)

  Shopify's Google & YouTube channel already sends page_view, view_item_list, view_item and
  add_to_cart (verified on the live store), so those are deliberately not duplicated here.

  Consent: only fires when the visitor accepted analytics in the banner
  (window.kxConsent, set by snippets/kalipso-cookie-consent.liquid). No choice yet means no
  event, matching how GA itself is gated.
*/
(function () {
  function allowed() {
    return !!(window.kxConsent && window.kxConsent.analytics);
  }

  /*
    Wait for gtag instead of giving up on it. Measured on the live cart page 2026-09-26:
    at DOMContentLoaded `window.gtag` is undefined and `window.kxConsent` is still null —
    Shopify's Google & YouTube channel and the consent banner both arrive later. The old
    code returned on the spot when gtag was missing, so EVERY event raised at
    DOMContentLoaded was dropped in silence. That is exactly where generate_lead is raised,
    which is why the store's real conversion never reached GA4, while the interaction
    events (begin_checkout, contact_click, select_item …) worked: by the time a visitor
    clicks anything, gtag exists.
  */
  function whenGtag(cb) {
    if (typeof window.gtag === 'function') { cb(); return; }
    var tries = 0;
    var t = setInterval(function () {
      if (typeof window.gtag === 'function') { clearInterval(t); cb(); }
      else if (++tries > 50) { clearInterval(t); }   // ~10s, then let it go
    }, 200);
  }

  function send(name, params) {
    whenGtag(function () {
      if (allowed()) { window.gtag('event', name, params || {}); return; }
      // no choice yet, or refused: send it only if the visitor accepts afterwards
      document.addEventListener('kx:consent', function once(e) {
        document.removeEventListener('kx:consent', once);
        if (e.detail && e.detail.analytics && typeof window.gtag === 'function') {
          window.gtag('event', name, params || {});
        }
      });
    });
  }

  function cartPayload() {
    var el = document.getElementById('kx-ga-cart');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /*
    Google Ads. The same lead, reported to Ads as a conversion: conversion action
    "Заявка за оферта" in AW-18476397642, created 2026-09-26. There is no tag to install —
    Shopify's Google & YouTube channel already loads AW-18476397642 on every page (measured
    live), so this only adds the event.

    Gated on the MARKETING toggle, not analytics: the banner lets a visitor accept analytics
    and refuse marketing, and in that case GA4 may have the lead but Ads must not.
  */
  // Two actions since 2026-10-11, so an order request and a general question are counted apart:
  // "Поръчка" (the cart order form, carries the cart value) and "Запитване" (the contact form).
  var ADS_SEND_TO = {
    order: 'AW-18476397642/vF2rCK_-xYYdEMronepE',
    contact: 'AW-18476397642/v48NCIKMw5kdEMronepE',
    // "Обаждане (сайт)", 2026-10-29: a tap on a phone number (the phone bar's "Обадете се",
    // the header, the cart, the contact page). Counted once per visit.
    call: 'AW-18476397642/sOizCLHIwK4dEMronepE'
  };

  function adsConversion(where, params) {
    var p = params || {};
    p.send_to = ADS_SEND_TO[where] || ADS_SEND_TO.contact;
    function fire() { window.gtag('event', 'conversion', p); }
    whenGtag(function () {
      if (window.kxConsent && window.kxConsent.marketing) { fire(); return; }
      // accepted after the fact: send it once the visitor agrees
      document.addEventListener('kx:consent', function once(e) {
        document.removeEventListener('kx:consent', once);
        if (e.detail && e.detail.marketing && typeof window.gtag === 'function') fire();
      });
    });
  }

  // once per browser tab per order, so a reload of the success page cannot count twice
  function onceInSession(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
    } catch (e) { /* private window: fall through and send */ }
    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 1. the order form was submitted successfully — the conversion
    var ok = document.querySelector('[data-kx-lead]');
    if (ok) {
      var cart = cartPayload() || {};
      var where = ok.getAttribute('data-kx-lead') || 'form';
      if (onceInSession('kx_lead_' + where + '_' + (cart.value || 0))) {
        send('generate_lead', {
          currency: cart.currency || 'EUR',
          value: cart.value || 0,
          lead_source: where,            // "order" from the cart, "contact" from Контакти
          items: cart.items || undefined
        });
        // the cart order form reports its value; the contact form is a plain enquiry
        if (where === 'order') adsConversion('order', { currency: cart.currency || 'EUR', value: cart.value || 0 });
        else adsConversion('contact');
      }
    }

    // 2. the shopper starts filling the order form — the equivalent of begin_checkout
    var form = document.getElementById('kx-order-form');
    if (form) {
      form.addEventListener('focusin', function start() {
        form.removeEventListener('focusin', start);
        var cart = cartPayload() || {};
        send('begin_checkout', {
          currency: cart.currency || 'EUR',
          value: cart.value || 0,
          items: cart.items || undefined
        });
      });
    }
  });

  // 3. phone and email taps, anywhere on the site
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"], a[href^="mailto:"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    send('contact_click', {
      method: href.indexOf('tel:') === 0 ? 'phone' : 'email',
      link_url: href,
      page_location: location.pathname
    });
    if (href.indexOf('tel:') === 0 && onceInSession('kx_call')) adsConversion('call');
  }, true);

  // ---- behaviour on the page -------------------------------------------------
  // GA4's enhanced measurement already reports scroll, outbound clicks,
  // view_search_results and user_engagement. These are the five it cannot know about.

  function itemOf(card) {
    if (!card) return null;
    return {
      item_id: card.getAttribute('data-kx-id') || undefined,
      item_name: card.getAttribute('data-kx-name') || undefined,
      item_brand: card.getAttribute('data-kx-brand') || undefined,
      price: parseFloat(card.getAttribute('data-kx-price')) || undefined
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 4. a search that found nothing — the report that caught customers looking for
    //    products sitting in draft (see the GA analysis of 25.09)
    var meta = document.getElementById('kx-search-meta');
    if (meta && meta.getAttribute('data-count') === '0') {
      var term = meta.getAttribute('data-term') || '';
      if (term && onceInSession('kx_nores_' + term)) {
        send('search_no_results', { search_term: term });
      }
    }
  });

  // 5. which card in a list actually gets opened. On pointerdown, not click: the click
  //    navigates, and the event was being lost in the unload (measured — it never arrived).
  document.addEventListener('pointerdown', function (e) {
    var tile = e.target && e.target.closest ? e.target.closest('a.kx-tile') : null;
    if (!tile) return;
    var card = tile.closest('.kx-tile-wrap');
    var item = itemOf(card);
    var grid = card && card.closest ? card.closest('.kx-pgrid') : null;
    if (item && item.item_id) {
      send('select_item', {
        item_list_name: (grid && grid.getAttribute('data-kx-list')) || 'Списък',
        items: [item]
      });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 6. the favourites heart — intent without an order
    var fav = t.closest('[data-kx-fav]');
    if (fav) {
      if (fav.getAttribute('data-kx-fav-kind') === 'collection') return;   // saving a category, not a product
      var item2 = itemOf(fav.closest('.kx-tile-wrap')) || { item_id: fav.getAttribute('data-kx-fav') };
      // the button toggles, so only the turning-on half is a signal
      if (fav.getAttribute('aria-pressed') !== 'true') {
        send('add_to_wishlist', { currency: 'EUR', value: item2.price || 0, items: [item2] });
      }
      return;
    }

    // 7. a technical sheet or drawing — GA4's own file_download misses these,
    //    because Alcadrain and Ideal Standard serve PDFs from .php URLs
    var doc = t.closest('a[href]');
    if (doc) {
      var href = doc.getAttribute('href') || '';
      if (/\.pdf($|\?)|techlist|dfsmedia|productSheet|pdf_products_lang/i.test(href)) {
        send('view_tech_doc', {
          doc_url: href.slice(0, 200),
          doc_type: /drw|drawing|dimdraw|чертеж/i.test(href + ' ' + (doc.textContent || '')) ? 'drawing' : 'pdf',
          item_name: document.querySelector('h1') ? document.querySelector('h1').textContent.trim().slice(0, 100) : undefined
        });
      }
    }
  }, true);

  // 9-11. steps that show intent before a request (owner, 4 Nov 2026: add to cart is close to zero,
  //       tile buyers ask before they order): the m2 calculator, opening the "Запитване" sheet,
  //       adding to the comparison. Key events stay generate_lead and contact_click.
  function pageItem() {
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim().slice(0, 100) : undefined;
  }
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.matches('[data-kx-m2-w], [data-kx-m2-h]')) return;
    var box = el.closest('.kxpr-m2');
    var w = box && box.querySelector('[data-kx-m2-w]'), h = box && box.querySelector('[data-kx-m2-h]');
    var a = w && h ? (parseFloat(String(w.value).replace(',', '.')) || 0) * (parseFloat(String(h.value).replace(',', '.')) || 0) : 0;
    if (a > 0 && onceInSession('kx_calc_' + location.pathname)) {
      send('calculator_use', { item_name: pageItem(), area_m2: Math.round(a * 10) / 10 });
    }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-kx-qc-open]')) {
      send('quick_request_open', { page_path: location.pathname.slice(0, 100), item_name: pageItem() });
      return;
    }
    var cmp = t.closest('[data-kx-cmp]');
    // the button toggles, so only the adding half counts
    if (cmp && cmp.getAttribute('aria-pressed') !== 'true') {
      var card = cmp.closest('.kx-tile-wrap');
      send('add_to_compare', { items: [itemOf(card) || { item_id: cmp.getAttribute('data-kx-cmp') }] });
    }
  }, true);

  // 8. do the filters get used at all — they were a lot of work
  function filterGroup(el) {
    var g = el.closest ? el.closest('.kx-fgroup') : null;
    var label = g && g.querySelector('span');
    return (label && label.textContent.trim()) || 'Филтър';
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest('.kx-fgroup')) return;
    send('filter_use', {
      filter_type: filterGroup(el),
      filter_value: (el.value || '').slice(0, 60),
      filter_action: el.checked === false ? 'off' : 'on'
    });
  }, true);
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.kx-fgroup a.kx-chip--link') : null;
    if (!link) return;
    send('filter_use', {
      filter_type: filterGroup(link),
      filter_value: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60),
      filter_action: link.classList.contains('is-on') ? 'off' : 'on'
    });
  }, true);
})();
